<template>
    <div class="auth-card">
        <div class="auth-card-container">
            <h3 v-if="title">{{ $te(title) ? $t(title) : title }}</h3>

            <div class="auth-card-body">
                <slot/>
            </div>
        </div>

        <slot name="append"/>
    </div>
</template>

<script>
export default {
    name: "AuthCard",
    props: {
        title: {
            type: String,
            default: ""
        }
    }
}
</script>

<style scoped>

</style>